"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var InputHint = function InputHint(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledInputHint, {
    className: className
  }, children);
};
var StyledInputHint = _styledComponents["default"].div.withConfig({
  displayName: "InputHint__StyledInputHint",
  componentId: "sc-xlk5w7-0"
})(["margin-top:4px;color:", ";max-width:fit-content;"], _userflow["default"].colors.greyLight);
var _default = exports["default"] = InputHint;